/* eslint-disable react/jsx-fragments */
import React from "react";
import Nav from "reactstrap/lib/Nav";
import NavItem from "reactstrap/lib/NavItem";
import NavLink from "reactstrap/lib/NavLink";
import UncontrolledCollapse from "reactstrap/lib/UncontrolledCollapse";
import DropdownItem from "reactstrap/lib/DropdownItem";
import Button from "reactstrap/lib/Button";
import ChevronDefaultRight from "@druva-apps/orion-icons/lib/ChevronsmallrightGreyOutline";
import NewTab from "@druva-apps/orion-icons/lib/NewtabGreyOutline";

import OrionButton from "../components/button/button";
import OrganizationSelect from "../components/headerbar/organizationSelect";
import Progress from "../components/progress/progress";
import {
  gatherClasses,
  gatherConditionalProps,
  isFunction,
  hasProperty
} from "./utils";
import { getBadgeColor } from "./headerbarUtils";
import DropdownSelect from "../components/headerbar/dropdownSelect";
import Loader from "../components/loader/loader";

export default class HeaderbarRespUtils {
  constructor(closeSidebar, context) {
    this.closeSidebar = closeSidebar;
    this.context = context;
  }

  renderComponents = (items, prefix) => {
    const components = [];

    items.forEach((item, index) => {
      if (item.component === "link") {
        components.push(this.renderLink(item.data, `${prefix}-${index}`));
      } else if (item.component === "dropdown") {
        components.push(this.renderDropdown(item.data, `${prefix}-${index}`));
      } else if (item.component === "select") {
        components.push(this.renderSelect(item.data, `${prefix}-${index}`));
      } else if (
        item.component === "icon" ||
        item.component === "icon-popover"
      ) {
        components.push(
          this.renderIcon(item.data, `${prefix}-${index}`, this.context)
        );
      } else if (item.component === "icon-dropdown") {
        components.push(
          this.renderIconDropdown(item.data, `${prefix}-${index}`, this.context)
        );
      } else if (item.component === "organization-select") {
        components.push(
          this.renderOrganizationSelect(item.data, `${prefix}-${index}`)
        );
      } else if (item.component === "profile") {
        components.push(this.renderProfile(item.data, `${prefix}-${index}`));
      } else if (item.component === "button") {
        components.push(this.renderButton(item.data, `${prefix}-${index}`));
      } else if (item.component === "custom") {
        components.push(
          this.renderCustomComponent(item.data, `${prefix}-${index}`)
        );
      } else if (item.component === "progress") {
        components.push(this.renderProgress(item.data, `${prefix}-${index}`));
      } else if (item.component === "megamenu") {
        components.push(
          this.renderMegaMenuPopover(item.data, `${prefix}-${index}`)
        );
      }
    });

    return components;
  };

  renderButton = (button, index) => {
    const { label, icon, disabled, isActive, onClick, className } = button;
    return (
      <NavItem key={index}>
        <OrionButton
          label={label}
          icon={icon}
          disabled={disabled}
          active={isActive}
          onClick={onClick}
          type="primary"
          className={gatherClasses(null, "oui-rhb-button", className || "")}
        />
      </NavItem>
    );
  };

  renderProgress = (obj, key) => {
    const { value, valueLabel, label } = obj;
    let sizeClass = "";

    if (valueLabel) {
      const valueLabelLength = String(valueLabel);
      if (valueLabelLength.length === 2) {
        sizeClass = "oui-value-lg";
      } else if (valueLabelLength.length === 3) {
        sizeClass = "oui-value-md";
      } else if (valueLabelLength.length === 4) {
        sizeClass = "oui-value-sm";
      } else if (valueLabelLength.length >= 5) {
        sizeClass = "oui-value-xs";
      }
    }

    return (
      <NavItem key={key}>
        <Progress
          className={gatherClasses(
            null,
            "oui-headerbar-progress",
            sizeClass,
            "oui-pl-2",
            "oui-pr-2"
          )}
          type="circular"
          value={value}
          valueLabel={valueLabel}
          max={100}
          size="sm"
          showPercProgress
          label={label}
          labelPlacement="right"
        />
      </NavItem>
    );
  };

  renderLink = (item, key) => {
    return (
      <NavItem key={key}>
        {isFunction(item.renderComponent) ? (
          item.renderComponent(
            item,
            key,
            "oui-active",
            "oui-nav-link",
            this.closeSidebar
          )
        ) : (
          <NavLink
            className={gatherClasses(null, item.isActive ? "oui-active" : null)}
            onClick={e => {
              this.handleItemClick();
              if (isFunction(item.onClick)) {
                item.onClick(e);
              }
            }}
            {...gatherConditionalProps(item, "href", "disabled", "target")}
          >
            {item.name || item.label}
          </NavLink>
        )}
      </NavItem>
    );
  };

  renderDropdown = (item, key, megaMenuProp) => {
    return (
      <React.Fragment key={`fg-${key}`}>
        <NavItem className={item.className ? item.className : null}>
          <NavLink
            id={`fg-collapse-${key}`}
            href="#"
            disabled={item.disabled}
            onClick={() => this.toggleClass(key)}
            className={gatherClasses(
              null,
              "oui-collapse-trigger-link",
              item.isActive ? "oui-active" : null
            )}
          >
            <span className="oui-collapse-icon">
              <ChevronDefaultRight inheritFontColor muted={false} />
            </span>

            {item.label || item.title}
          </NavLink>
        </NavItem>
        <UncontrolledCollapse tag="li" toggler={`#fg-collapse-${key}`}>
          <ul className="oui-collapse-container">
            {megaMenuProp === "megamenu"
              ? this.renderMegaMenuItems(item.items, key)
              : this.renderChildItems(item.items, key, item.onItemClick)}
          </ul>
        </UncontrolledCollapse>
      </React.Fragment>
    );
  };

  /* Create Mega Menu Popover Content */
  renderMegaMenuPopover = (obj, key) => {
    const { columns, title } = obj;

    const items = [];

    columns.forEach(column => {
      if (isFunction(column.renderComponent)) {
        const newColumnComponent = {
          heading: column.header ? column.header.text : null,
          href: column.header ? column.header.href : null,
          onItemClick: column.header ? column.header.onClick : null,
          target: column.header ? column.header.target : null,
          items: [{ renderComponent: column.renderComponent }]
        };
        items.push(newColumnComponent, { divider: true });
      } else {
        const columnsLinks = this.renderMegaMenuBodyLinks(column, key);
        if (columnsLinks && Object.keys(columnsLinks).length > 0) {
          items.push(columnsLinks, { divider: true });
        }
      }
    });

    const dropdown = {
      label: title,
      items
    };

    return (
      <div className="oui-mega-menu-resp-container">
        {this.renderDropdown(dropdown, key, "megamenu")}
      </div>
    );
  };

  /* Create Menu Link Objects */
  renderMegaMenuBodyLinks = column => {
    const { text, onClick, href } = column.header;
    const { links } = column;

    return {
      heading: text,
      onItemClick: onClick,
      href,
      items:
        links && links.length > 0
          ? links.map(link => ({
              label: link.text,
              children: link.children,
              onItemClick: isFunction(link.onClick) ? link.onClick : null,
              href: link.href ? link.href : null
            }))
          : null
    };
  };

  /* Create Mega Menu Links and Custom Content */
  renderMegaMenuItems = (menuItems, key) => {
    return menuItems.map((menuItem, ind) => {
      if (!menuItem) {
        return null;
      }
      const { items } = menuItem;

      if (hasProperty(menuItem, "divider")) {
        return <DropdownItem divider key={`${key}-${ind}`} />;
      }

      return (
        <NavItem key={`${key}-${ind}`}>
          <div className="oui-group-header oui-mega-menu-column__header">
            {this.renderMegaMenuColumnHeader(menuItem)}
          </div>

          {/* Render Mega Menu links */}
          {items &&
            items.map(item =>
              isFunction(item.renderComponent)
                ? item.renderComponent(
                    item,
                    key,
                    "oui-active",
                    "oui-nav-link oui-nav-link-inner",
                    this.closeSidebar
                  )
                : this.renderMegaMenuLinks(item, ind)
            )}
        </NavItem>
      );
    });
  };

  renderMegaMenuLinks = (item, key) => {
    /* If link has a children, then render children dropdown again */
    if (item.children) {
      const children = {
        label: item.label,
        onItemClick: item.onItemClick,
        className: "oui-megamenu-sublinks",
        items: item.children.map(sublink => ({
          label: sublink.text,
          onItemClick: isFunction(sublink.onClick) ? sublink.onClick : null,
          href: sublink.href ? sublink.href : null,
          target: sublink.target || "_blank"
        }))
      };
      return this.renderDropdown(children, `subMenuLinks-${key}`);
    }
    return (
      <NavLink
        className={gatherClasses(
          null,
          item.isActive ? "oui-active" : null,
          "oui-nav-link-inner"
        )}
        onClick={e => {
          this.handleItemClick();
          if (isFunction(item.onItemClick)) {
            e.preventDefault();
            item.onItemClick(e, item);
          }
        }}
        {...gatherConditionalProps(item, "href", "disabled", "target")}
      >
        {item.label}
      </NavLink>
    );
  };

  renderMegaMenuColumnHeader = menuitem => {
    const { href, target, onItemClick, heading } = menuitem;
    const columnHeader =
      target === "_blank" ? (
        <>
          {heading}
          <NewTab
            muted={false}
            inheritFontSize
            inheritFontColor
            className="oui-ml-2"
          />
        </>
      ) : (
        heading
      );

    if (href) {
      return (
        <a
          href={href}
          target={target || "_blank"}
          className="oui-mega-menu-column__header-link"
          onClick={
            isFunction(onItemClick)
              ? e => {
                  e.preventDefault();
                  onItemClick(e, menuitem);
                }
              : null
          }
        >
          {columnHeader}
        </a>
      );
    }
    return columnHeader;
  };

  renderSelect = (item, key) => {
    return <DropdownSelect key={key} {...item} callback={this.closeSidebar} />;
  };

  renderOrganizationSelect = (obj, key) => {
    return (
      <li className="oui-headerbar-org-select oui-is-responsive" key={key}>
        <OrganizationSelect {...obj} isResponsive />
      </li>
    );
  };

  renderChildItems = (items, key, onItemClick) => {
    return items.map((item, ind) => {
      if (hasProperty(item, "heading")) {
        return this.renderHeadingItems(item, `${key}-${ind}`, onItemClick);
      }

      if (hasProperty(item, "divider")) {
        return <DropdownItem divider key={`${key}-${ind}`} />;
      }

      return (
        <NavItem key={`${key}-${ind}`}>
          {isFunction(item.renderComponent) ? (
            item.renderComponent(
              item,
              key,
              "oui-active",
              "oui-nav-link oui-nav-link-inner",
              this.closeSidebar
            )
          ) : (
            <NavLink
              className={gatherClasses(
                null,
                item.isActive ? "oui-active" : null,
                "oui-nav-link-inner"
              )}
              onClick={e => {
                e.stopPropagation();
                this.handleItemClick();
                if (isFunction(onItemClick)) {
                  onItemClick(item);
                } else if (item && isFunction(item.onItemClick)) {
                  item.onItemClick(e, item);
                }
              }}
              {...gatherConditionalProps(item, "href", "disabled", "target")}
            >
              {item.name || item.label}
              {item.items &&
                this.renderChildItems(item.items, item.label, onItemClick)}
            </NavLink>
          )}
        </NavItem>
      );
    });
  };

  renderHeadingItems = (item, key, onItemClick) => {
    return (
      <React.Fragment key={`fg-${key}`}>
        <h6 className="oui-group-header">{item.heading}</h6>
        {this.renderChildItems(item.items, key, onItemClick)}
      </React.Fragment>
    );
  };

  renderIcon = (item, key, context) => {
    return (
      <NavItem key={key}>
        <NavLink
          className="oui-icon-comp"
          active={item.isActive}
          {...gatherConditionalProps(item, "href", "target", "disabled")}
          onClick={e => {
            this.handleItemClick();
            if (isFunction(item.onClick)) {
              item.onClick(e);
            }
          }}
        >
          <span className="oui-icon-title">{item.title}</span>
          {item.badge ? (
            <span
              className="oui-badge"
              style={{
                backgroundColor:
                  getBadgeColor(context && context.isDellApplication())[
                    item.badge.type
                  ] || item.badge.color
              }}
            >
              {item.badge.label}
            </span>
          ) : null}
        </NavLink>
      </NavItem>
    );
  };

  renderIconDropdown = (item, key, context) => {
    return (
      <React.Fragment key={`fg-${key}`}>
        <NavItem key={key}>
          <NavLink
            id={`fg-collapse-${key}`}
            active={item.isActive}
            disabled={item.disabled}
            href="#"
            onClick={() => this.toggleClass(key)}
            className="oui-collapse-trigger-link oui-icon-comp"
          >
            <span className="oui-collapse-icon">
              <ChevronDefaultRight inheritFontColor muted={false} />
            </span>
            {item.title}
            {item.badge ? (
              <span
                className="oui-badge"
                style={{
                  backgroundColor:
                    getBadgeColor(context && context.isDellApplication())[
                      item.badge.type
                    ] || item.badge.color
                }}
              >
                {item.badge.label}
              </span>
            ) : null}
          </NavLink>
        </NavItem>
        <UncontrolledCollapse tag="li" toggler={`#fg-collapse-${key}`}>
          <ul className="oui-collapse-container">
            {this.renderChildItems(item.dropdown.items, key, item.onItemClick)}
          </ul>
        </UncontrolledCollapse>
      </React.Fragment>
    );
  };

  renderCustomComponent = (item, index) => {
    return (
      <NavItem className="oui-my-2" key={index}>
        {isFunction(item) ? item() : null}
      </NavItem>
    );
  };

  renderProfile = (profile, key) => {
    return (
      <React.Fragment key={key}>
        {profile.isLoading ? (
          <div className="oui-profile-loading-container">
            {profile.renderLoadingComponent ? (
              profile.renderLoadingComponent()
            ) : (
              <Loader isLoading />
            )}
          </div>
        ) : (
          <React.Fragment>
            <NavItem key={key}>
              <NavLink
                active={profile.isActive}
                className={gatherClasses(
                  null,
                  "oui-profile-username",
                  "oui-text-truncate"
                )}
                onClick={e => {
                  this.handleItemClick();
                  if (isFunction(profile.user.onClick)) {
                    profile.user.onClick(e);
                  }
                }}
                {...gatherConditionalProps(
                  profile.user,
                  "href",
                  "disabled",
                  "target"
                )}
              >
                {profile.user.name}
              </NavLink>
            </NavItem>
            {profile.links && profile.links.length > 0 && (
              <div className="oui-extra-links">
                <Nav vertical>
                  {profile.links.map((linkObj, index) => {
                    return (
                      <NavItem key={index}>
                        {isFunction(linkObj.renderComponent) ? (
                          linkObj.renderComponent(
                            linkObj,
                            "oui-nav-link",
                            this.handleItemClick
                          )
                        ) : (
                          <NavLink
                            active={linkObj.isActive}
                            {...gatherConditionalProps(
                              linkObj,
                              "href",
                              "target",
                              "disabled"
                            )}
                            onClick={e => {
                              this.handleItemClick();
                              if (isFunction(linkObj.onClick)) {
                                linkObj.onClick(e, linkObj);
                              }
                            }}
                          >
                            {linkObj.name}
                          </NavLink>
                        )}
                      </NavItem>
                    );
                  })}
                </Nav>
              </div>
            )}
            {isFunction(profile.renderContent) && (
              <div className="oui-profile-content oui-p-3 oui-text-white">
                {profile.renderContent(this.handleItemClick)}
              </div>
            )}
          </React.Fragment>
        )}

        <NavItem className="oui-profile-logout">
          <Button
            color="primary"
            size="sm"
            tag="a"
            href={profile.logout.href || "#"}
            target={profile.logout.target}
            onClick={e => {
              this.handleItemClick();
              if (isFunction(profile.logout.onClick)) {
                profile.logout.onClick(e);
              }
            }}
          >
            <span>{profile.logout.label || "Sign out"}</span>
          </Button>
        </NavItem>
      </React.Fragment>
    );
  };

  toggleClass = togglerId => {
    const el = document.querySelector(`#fg-collapse-${togglerId}`);
    if (el && el.classList.contains("oui-expanded")) {
      el.classList.remove("oui-expanded");
    } else {
      el.classList.add("oui-expanded");
    }
  };

  handleItemClick = () => {
    this.closeSidebar();
  };
}
